module.exports = __webpack_public_path__ + "static/banner-c040faf6922c3fa8d7c4de591257afbc.svg";